<template>
    <div>
        <div class="row data-form">
            <div class="col-12">
                <div class="border px-5 pt-5 pb-2 mb-4 rounded">
                    <div class="row">
                        <div class="col-12 col-md-6 col-lg">
                            <b-form-group :label="$t('student_number')">
                                {{ formObj.student_number }}
                            </b-form-group>
                        </div>
                        <div class="col-12 col-md-6 col-lg">
                            <b-form-group :label="$t('name_surname')">
                                {{ formObj.name + ' ' + formObj.surname }}
                            </b-form-group>
                        </div>

                        <div class="col-12 col-md-6 col-lg">
                            <b-form-group :label="$t('program')">
                                {{ formObj.program_name }}
                            </b-form-group>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <b-table
            :empty-text="this.$t('there_are_no_records')"
            bordered
            striped
            responsive
            :items="documentRequests"
            :fields="documentRequestFields"
            show-empty
            class="mb-5 table-dropdown no-scrollbar border rounded">
            <template #cell(buttons)="row">
                <b-dropdown variant="link btn-sm" boundary="window" no-caret>
                    <template #button-content>
                        <i class="ri-more-fill"></i>
                    </template>
                    <div id="dropdownListHead">
                      <b-dropdown-item @click="updateStatusFormShow(row.item)" v-if="checkPermission('documentrequest_updatestatus')">
                        <i class="ri-file-transfer-line align-middle top-minus-1 mr-3 text-muted"></i> {{$t('status_update')}}
                      </b-dropdown-item>
                      <b-dropdown-item @click="uploadTranscriptFormShow(row.item)" v-if="row.item.document_type === 'mentora_transcript' && checkPermission('documentrequest_uploadtranscript')">
                        <i class="ri-upload-2-line align-middle top-minus-1 mr-3 text-muted"></i> {{$t('upload_scanned_transcript')}}
                      </b-dropdown-item>
                    </div>
                </b-dropdown>
            </template>
        </b-table>
      <CommonModal ref="updateStatusFormModal" size="md" :onHideOnlyX="true">
        <template v-slot:CommonModalTitle>
          {{ $t('status_update').toUpper() }}
        </template>
        <template v-slot:CommonModalContent>
          <update-status-form :id="requestId" :currentStatus="currentStatus" @hide="updateStatusFormSuccess" />
        </template>
      </CommonModal>
      <CommonModal ref="uploadTranscriptFormModal" size="md" :onHideOnlyX="true">
        <template v-slot:CommonModalTitle>
          {{ $t('upload_scanned_transcript').toUpper() }}
        </template>
        <template v-slot:CommonModalContent>
          <upload-transcript-form :id="requestId" @hide="uploadTranscriptFormSuccess" />
        </template>
      </CommonModal>
    </div>
</template>

<script>
// Services
import DocumentRequestService from "@/services/DocumentRequestService";

// Other
import qs from "qs";
import AppLayout from "@/layouts/AppLayout"
import CommonModal from "@/components/elements/CommonModal";
import UpdateStatusForm from "./UpdateStatusForm";
import UploadTranscriptForm from "./UploadTranscriptForm";

export default {
    components: {
        AppLayout,
        CommonModal,
        UpdateStatusForm,
        UploadTranscriptForm,
    },
    props: {
        formObj: {
            type: Object,
        }
    },
    data() {
        return {
            requestId: 0,
            currentStatus: null,
            documentRequests: [],
            documentRequestFields: [
                {
                    key: 'buttons',
                    label: '',
                    thClass: 'width-50'
                },
                {
                    key: 'document_type_name',
                    label: this.$t('document_type'),
                },
                {
                    key: 'date',
                    label: this.$t('date').toUpper(),
                },
                {
                    key: 'price',
                    label: this.$t('price'),
                },
                {
                    key: 'status_name',
                    label: this.$t('status'),
                },
                {
                    key: 'id',
                    label: '',
                    thClass: 'd-none',
                    tdClass: 'd-none'
                },
            ],
        }
    },
    watch: {
        formObj: function (val) {
            this.get(val)
        }
    },
    async created() {
        await this.get(this.formObj)
    },
    methods: {
        get(obj) {
            let config = {
                params: {
                    filter: {
                        id: this.formObj.id
                    }
                },
                paramsSerializer: (params) => qs.stringify(params, {encode: false})
            }
            DocumentRequestService.getStudentDocuments(obj.student_program_id, config).then(response => {
                this.documentRequests = response.data.data;
            }).catch(e => {

            })
        },

        updateStatusFormShow(obj) {
            this.requestId = obj.id
            this.currentStatus = obj.status
            this.$refs.updateStatusFormModal.$refs.commonModal.show()
        },
        updateStatusFormSuccess() {
            this.$refs.updateStatusFormModal.$refs.commonModal.hide()
            this.get(this.formObj)
        },
        uploadTranscriptFormShow(obj) {
            this.requestId = obj.id
            this.$refs.uploadTranscriptFormModal.$refs.commonModal.show()
        },
        uploadTranscriptFormSuccess() {
            this.$refs.uploadTranscriptFormModal.$refs.commonModal.hide()
            this.get(this.formObj)
        },


    },


}
</script>
